import { Input } from "antd";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import CustomFormItem from "../../components/CustomFormItem/CustomFormItem";
import { isPDFFileType } from "../../utils/utils";
import PDFIcon from "./PDFIcon";

const RANDOM = new Date().getTime();

const getListStyle = (isDraggingOver, isPlaceholder) =>
  // let background = isDraggingOver ? "lightblue" : "rgb(239 239 239)";
  // let border = 0;
  // if (!isDraggingOver && !isPlaceholder) {
  //   border = "2px solid #e4e4e4";
  //   background = "#fff";
  // }
  ({
    background: isDraggingOver ? "lightblue" : "#fefefe",
    // overflow: "auto",
    // display: "flex",
    // flexWrap: "wrap",
    // border: "2px solid #e4e4e4",
    // height: "160px",
    display: "flex",
    height: "inherit" || "100%",
    justifyContent: "center",
  });
const getItemStyle = (isDragging, draggableStyle, isPlaceholder) => {
  let background = isDragging ? "lightgreen" : "rgb(239 239 239)";
  let border = "2px solid #e4e4e4";
  if (!isDragging && !isPlaceholder) {
    background = "#fff";
    border = 0;
  }

  // if (!isDragging && !hasItems)

  return {
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    // borderRadius: "5px",
    // some basic styles to make the items look a bit nicer
    userSelect: "text",
    // padding: grid * 2,
    // margin: "10px",
    // change background colour if dragging
    // background: isDragging ? "lightgreen" : "rgb(239 239 239)",
    background,
    border,
    // height: "140px",
    height: "inherit" || "100%",
    width: "100%",
    // styles we need to apply on draggables
    ...draggableStyle,
  };
};

const CustomDroppable = ({
  className,
  fileType,
  list,
  type,
  isDropDisabled,
  previewFile,
  placeholderText,
  isDragDisabled,
  altLabel,
}) => {
  const [textSelectable, setTextSelectable] = useState(false);
  const acceptedFileTypes = Array.isArray(fileType) ? fileType.join(",") : fileType;

  const { t } = useTranslation();
  return (
    <div className={`property-media__container ${className}`} data-file-types={acceptedFileTypes}>
      <Droppable droppableId={type} direction="vertical" isDropDisabled={isDropDisabled}>
        {(provided1, snapshot1) => {
          if (!list.length) {
            return (
              <div
                ref={provided1.innerRef}
                style={{
                  ...getItemStyle(snapshot1.isDraggingOver, {}, true),
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "12px",
                }}
                className="property-media__container-placeholder"
              >
                <div className="text-center">{placeholderText}</div>
              </div>
            );
          }
          return (
            <div ref={provided1.innerRef} style={getListStyle(snapshot1.isDraggingOver, false)}>
              {list.length ? (
                list.map((item, index) => {
                  const _url = `${item.thumbnails_webimage_url}?ver=${RANDOM}`;
                  const _alt = item.asset_name;

                  // if (isPDFFileType(item)) {
                  //   _url = getThumbnailByType(_url);
                  //   _alt = "PDF";
                  // }
                  const isPDF = isPDFFileType(item);
                  if (snapshot1.isDraggingOver && snapshot1.draggingFromThisWith !== snapshot1.draggingOverWith) {
                    return null;
                  }

                  return (
                    <Draggable
                      key={item.asset_id}
                      draggableId={item.asset_id}
                      index={index}
                      isDragDisabled={isDragDisabled || textSelectable}
                    >
                      {(provided, snapshot) => (
                        <div style={{ width: "100%" }}>
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="property-media__container-item"
                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style, false)}
                          >
                            <div
                              onDoubleClick={() => previewFile(item)}
                              className="property-media__container-item-hover"
                            >
                              <img
                                className={`item-image ${isPDF ? "pdf" : ""}`}
                                // className="item-image"
                                src={_url}
                                alt={_alt}
                              />
                              <div
                                className="id-container text-center"
                                onMouseEnter={() => setTextSelectable(true)}
                                onMouseLeave={() => setTextSelectable(false)}
                              >
                                {item.asset_id}
                                {""}
                                {/* Removed <span> */}
                                <PDFIcon item={item} isPDF={isPDF} />
                              </div>
                              {/* <div className="text-center">{item.name}</div> */}
                            </div>
                            {/* <PDFIcon item={item} isPDF={isPDF} className="external-link" /> */}
                          </div>
                          {!isPDF && !snapshot.isDragging && (
                            <CustomFormItem
                              label={altLabel}
                              name={["media", type, 0, "alt_text"]}
                              rules={[
                                { required: true, max: 100, message: t("ErrorMessages.ImageDescriptionMessage") },
                              ]}
                              className="alt-details"
                            >
                              <Input />
                            </CustomFormItem>
                          )}
                        </div>
                      )}
                    </Draggable>
                  );
                })
              ) : (
                <div style={getItemStyle(false, {}, true)}>
                  <div>
                    <div className="text-center">{placeholderText}</div>
                  </div>
                </div>
              )}
              {provided1.placeholder}
            </div>
          );
        }}
      </Droppable>
    </div>
  );
};

CustomDroppable.propTypes = {
  className: PropTypes.string,
  fileType: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  previewFile: PropTypes.func,
  placeholderText: PropTypes.string,
  list: PropTypes.array,
  isDropDisabled: PropTypes.bool,
  isDragDisabled: PropTypes.bool,
  type: PropTypes.string,
  altLabel: PropTypes.string,
};

export default CustomDroppable;
